import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { Textarea } from '@1trading/react/components/ui/textarea';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionAmlCtfSanctionsOrDefaults } from '@/features/institution/aml-ctf-sanctions/schema';

const InstitutionAmlCtfSanctionsFieldsetGovernance = () => {
  const form = useFormContext<InstitutionAmlCtfSanctionsOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="policiesApprovedAnnually"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.governance.policiesApprovedAnnually')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.governance.policiesApprovedAnnually')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="recordRetentionCompliant"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.governance.recordRetentionCompliant')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.governance.recordRetentionCompliant')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="independentAmlAudit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.governance.independentAmlAudit')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.governance.independentAmlAudit')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="itAndSoftwareProviders"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.governance.itAndSoftwareProviders')}*</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('institutionDetails.amlCtfSanctions.placeholders.itAndSoftwareProviders')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionAmlCtfSanctionsFieldsetGovernance.displayName = 'InstitutionAmlCtfSanctionsFieldsetGovernance';

export { InstitutionAmlCtfSanctionsFieldsetGovernance };
